<template>
  <enb-seo-card comp="SeoPaginaPrincipal" label="Página principal"/>
</template>

<script>
import EnbSeoCard from './EnbSeoCard'
export default {
  name: 'EnbSeo',
  components: { EnbSeoCard }
}
</script>
